import React from 'react';
import styles from './index.module.scss';

const Password = ({ className }) => {
    return (
        <svg
            id='Group_9346'
            data-name='Group 9346'
            xmlns='http://www.w3.org/2000/svg'
            width='94'
            height='94'
            viewBox='0 0 94 94'
            className={className}
        >
            <circle
                id='Ellipse_115'
                data-name='Ellipse 115'
                cx='47'
                cy='47'
                r='47'
                className={styles.circle}
            />
            <g id='Group_9344' data-name='Group 9344' transform='translate(-33.085 19.628)'>
                <path
                    id='Path_3279'
                    data-name='Path 3279'
                    d='M100.085,11.789V32c-.02.024-.054.045-.063.072a4.008,4.008,0,0,1-4.391,3.3H83.408q-9.583,0-19.171,0a3.964,3.964,0,0,1-4.063-3.2A.747.747,0,0,0,60.085,32V11.789a9.488,9.488,0,0,1,.531-1.353,4.086,4.086,0,0,1,3.851-2.064q15.643.018,31.289.006c.134,0,.269,0,.406.006a4,4,0,0,1,3.829,3.18A1.7,1.7,0,0,0,100.085,11.789ZM72.616,27.365a8.981,8.981,0,1,0,14.866-10.08,8.326,8.326,0,0,0-5.766-3.792,9.1,9.1,0,0,0-8.146,2.574l-2.443-2.535v8.79h8.817l.083-.132-3.363-3.357a4.95,4.95,0,0,1,6.891-.126,5.012,5.012,0,0,1,.16,7.074,5.025,5.025,0,0,1-7.84-.591Z'
                    transform='translate(0 13.999)'
                    className={styles.icon}
                />
                <path
                    id='Path_3280'
                    data-name='Path 3280'
                    d='M90.452,18.378H88.827c-1.137,0-1.311-.186-1.394-1.3a10.133,10.133,0,0,0-4.683-8.13,9.918,9.918,0,0,0-15.123,6.774c-.1.564-.1,1.143-.149,1.716-.049.636-.329.924-.963.93q-2.006.023-4.011,0a1,1,0,0,1-1.011-1.089A16.3,16.3,0,0,1,74.4,1.671,15.985,15.985,0,0,1,93.207,14.589a24.122,24.122,0,0,1,.251,2.724c.043.738-.286,1.053-1.029,1.062C91.772,18.384,91.112,18.378,90.452,18.378Z'
                    transform='translate(2.613 0)'
                    className={styles.icon}
                />
            </g>
        </svg>
    );
};

export default Password;
